export default __webpack_public_path__ + "static/media/sound1.e69db03d.mp3";